"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInsureLoadV1EquipmentType = exports.emptyCarrierByMode = exports.getCarrierEntityByMode = exports.eStowageDetails = exports.TransportMode = exports.eTransportMode = void 0;
const utils_1 = require("@loadsure/utils");
const airCarrier_1 = __importDefault(require("./airCarrier"));
const carrier_class_1 = __importDefault(require("./carrier.class"));
const marineCarrier_1 = __importDefault(require("./marineCarrier"));
const parcelCarrier_1 = __importDefault(require("./parcelCarrier"));
const railCarrier_1 = __importDefault(require("./railCarrier"));
const roadCarrier_1 = __importDefault(require("./roadCarrier"));
var eTransportMode;
(function (eTransportMode) {
    eTransportMode["ROAD"] = "ROAD";
    eTransportMode["RAIL"] = "RAIL";
    eTransportMode["MARINE"] = "MARINE";
    eTransportMode["AIR"] = "AIR";
    eTransportMode["PARCEL"] = "PARCEL";
    eTransportMode["BARGE"] = "BARGE";
})(eTransportMode = exports.eTransportMode || (exports.eTransportMode = {}));
var TransportMode;
(function (TransportMode) {
    const primaryPrecedenceOrder = [
        eTransportMode.MARINE,
        eTransportMode.AIR,
        eTransportMode.PARCEL,
        eTransportMode.BARGE,
        eTransportMode.RAIL,
        eTransportMode.ROAD
    ];
    const primary = {
        [eTransportMode.MARINE]: "Marine",
        [eTransportMode.AIR]: "Air",
        [eTransportMode.ROAD]: "Road",
        [eTransportMode.RAIL]: "Rail",
        [eTransportMode.PARCEL]: "Parcel",
        [eTransportMode.BARGE]: "Barge"
    };
    const inland = {
        [eTransportMode.ROAD]: "Road",
        [eTransportMode.RAIL]: "Rail"
    };
    const data = Object.assign(Object.assign({}, primary), inland);
    function getItems() {
        return utils_1.objectToItems(data);
    }
    TransportMode.getItems = getItems;
    function getPrimaryItems() {
        return utils_1.objectToItems(primary);
    }
    TransportMode.getPrimaryItems = getPrimaryItems;
    function getInlandItems() {
        return utils_1.objectToItems(inland);
    }
    TransportMode.getInlandItems = getInlandItems;
    function getPrimaryMode(transportModes) {
        return primaryPrecedenceOrder.find((mode) => transportModes.includes(mode));
    }
    TransportMode.getPrimaryMode = getPrimaryMode;
})(TransportMode = exports.TransportMode || (exports.TransportMode = {}));
var eStowageDetails;
(function (eStowageDetails) {
    eStowageDetails["UNDER_DECK"] = "UNDER_DECK";
    eStowageDetails["ON_DECK"] = "ON_DECK";
})(eStowageDetails = exports.eStowageDetails || (exports.eStowageDetails = {}));
const getCarrierEntityByMode = (data) => {
    const mode = (data === null || data === void 0 ? void 0 : data.mode)
        ? utils_1.getEnumKey("mode", eTransportMode, data.mode)
        : "ROAD";
    if (mode === eTransportMode.RAIL) {
        return railCarrier_1.default.fromObj(data);
    }
    if (mode === eTransportMode.MARINE) {
        return marineCarrier_1.default.fromObj(data);
    }
    if (mode === eTransportMode.AIR) {
        return airCarrier_1.default.fromObj(data);
    }
    if (mode === eTransportMode.PARCEL) {
        return parcelCarrier_1.default.fromObj(data);
    }
    return roadCarrier_1.default.fromObj(data);
};
exports.getCarrierEntityByMode = getCarrierEntityByMode;
const emptyCarrierByMode = (mode) => {
    if (mode === eTransportMode.RAIL) {
        return railCarrier_1.default.empty();
    }
    if (mode === eTransportMode.MARINE) {
        return marineCarrier_1.default.empty();
    }
    if (mode === eTransportMode.AIR) {
        return airCarrier_1.default.empty();
    }
    if (mode === eTransportMode.PARCEL) {
        return parcelCarrier_1.default.empty();
    }
    return roadCarrier_1.default.empty();
};
exports.emptyCarrierByMode = emptyCarrierByMode;
const getInsureLoadV1EquipmentType = (carriers) => {
    let equipmentTypeId = 1;
    let equipmentType;
    if (carriers.length === 1) {
        const carrier = carriers[0];
        if (carrier instanceof roadCarrier_1.default) {
            equipmentTypeId = carrier.equipmentType;
            equipmentType = carrier.otherEquipmentType;
        }
    }
    return {
        equipmentTypeId,
        equipmentType
    };
};
exports.getInsureLoadV1EquipmentType = getInsureLoadV1EquipmentType;
exports.default = carrier_class_1.default;
//# sourceMappingURL=index.js.map